import Icon from '../components/Icon'

Icon.register({
  'exchange-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M0 168v-16c0-13.3 10.7-24 24-24h360v-48c0-21.4 25.9-32 41-17l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-15 15-41 4.5-41-17v-48h-360c-13.3 0-24-10.7-24-24zM488 320c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24h-360v48c0 21.4-25.9 32-41 17l-80-80c-9.4-9.4-9.4-24.6 0-33.9l80-80c15.1-15.1 41-4.3 41 17v48h360z'
      }
    ]
  }
})
